import request from '@/plugins/axios'

const prefix = 'job/employmentServiceSite'

/**
 * 下载导入模板
 * @returns {Promise}
 */
export function downloadServiceSiteTemplate() {
    return request({
        url: `/${prefix}/gl/v1.0.0/excelTemplateGain`,
        method: 'post',
        responseType: 'blob'
    })
}

/**
 * 导入服务站点
 */
export function importServiceSite(data) {
    return request({
        url: `/${prefix}/gl/v1.0.0/employmentServiceSiteImport`,
        method: 'post',
        data
    })
}

/**
 * 服务站点列表
 */
export function getServiceSiteList(data) {
    return request({
        url: `/${prefix}/gl/v1.0.0/page`,
        method: 'post',
        data
    })
}

/**
 * 删除服务站点
 */
export function deleteServiceSite(data) {
    return request({
        url: `/${prefix}/gl/v1.0.0/delete`,
        method: 'post',
        data
    })
}

/**
 * 新增服务站点
 */
export function addServiceSite(data) {
    return request({
        url: `/${prefix}/gl/v1.0.0/add`,
        method: 'post',
        data
    })
}

/**
 * 更新服务站点
 */
export function updateServiceSite(data) {
    return request({
        url: `/${prefix}/gl/v1.0.0/update`,
        method: 'post',
        data
    })
}
